// extracted by mini-css-extract-plugin
export default {"list":"Searched_list__w-j8b","end":"Searched_end__T2W94"};